module.exports = __webpack_public_path__ + "static/img/2.63f5ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad-server/2.png
// module id = 9bbo
// module chunks = 1